/** @format */
import { blue, orange } from '@mui/material/colors';
import { createTheme } from '@mui/material';
import { THEMES } from './Constants/commons';

export function useMUITheme(activeTheme) {
  const light = createTheme({
    palette: {
      mode: 'light',
      primary: {
        main: blue[500],
        dark: blue[600],
        light: blue[400],
      },
      secondary: {
        main: orange[400],
      },
      background: {
        paper: '#fdfcfa',
      },
    },
    typography: {
      fontFamily: 'sans-serif',
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          body: {
            backgroundColor: '#faf8f2',
          },
        },
      },
    },
  });

  const dark = createTheme({
    palette: {
      mode: 'dark',
    },
    typography: {
      body2: {
        // fontFamily: 'Hachi',
      },
      fontFamily: 'Inter',
    },
  });

  return activeTheme === THEMES.DARK ? dark : light;
}

// there is code
